import { pairs } from './pairs';

const environment = process.env.REACT_APP_KDA_NETWORK_TYPE || 'testnet';
const pairTokens = pairs[environment];

export default pairTokens;
